import React from "react";
import Seo from "../components/Seo";
import Footer from "../components/Footer";
import Hero from "../components/Heros/HeroBusiness";
import Cta from "../components/Cta";
import Feature from "../components/Features/FeatureSnowflake";


const Snowflake = () => (
    <>
        <Seo
            title="Snowflake AI Data Cloud"
            description="Snowflake Services Partner. 상호운용 가능한 스토리지와 탄력적 컴퓨팅, CORTEX AI를 기반으로 데이터 클라우드 전환을 지원합니다."
            path="/snowflake"
        />
        <Hero />
        <Feature />
        <Cta preset="contact" product="Snowflake" />
        <Footer />
    </>
);

export default Snowflake;
